import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IFullState } from '../../types/All.type';

const RequireAuth = () => {
  const userState = useSelector(
    (state: IFullState) => state.genesisUserRolePermission
  );
  const location = useLocation();
  if (userState.isAuthorized) {
    return <Outlet />;
  }
  sessionStorage.setItem('redirectPath', location.pathname);

  return <Navigate to='/' replace />;
};

export default RequireAuth;
